module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_f_albino.04b629c2.png";